<template>
  <table>
    <thead>
    <tr>
      <th v-if="attrLen > 0">{{ $t('audit.attribute') }}</th>
      <th v-if="oldLen > 0">{{ $t('audit.was') }}</th>
      <th>{{ attrLen > 0 ? $t('audit.now') : $t('audit.side_filters.deleted')  }}</th>
    </tr>
    </thead>
    <tbody v-if="attrLen > 0">
    <tr v-for="(value, label) in attributes" :key="label">
      <td :class="old[label] !== undefined && old[label] !== value && 'changed bgGrey'">
        {{ label }}:
      </td>
      <td v-if="oldLen > 0" :class="old[label] !== value && 'bgRed strikeThrough'">
        {{
          old[label] !== value ? old[label] : ''
        }}
      </td>
      <td :class="oldLen > 0 && old[label] !== value && 'bgGreen'">
        {{ value }}
      </td>
    </tr>
    </tbody>
    <tbody v-if="oldLen > 0 && attrLen === 0">
        <tr v-for="(value, label) in old" :key="label">
          <td style="white-space: nowrap">
            {{ label }}:
          </td>
          <td :class="value !== null && 'bgRed strikeThrough'">
            {{ value }}
          </td>
        </tr>
    </tbody>
  </table>

</template>

<script>

export default {
  name: 'DataTab',
  computed: {
    oldLen() {
      return this.old ? Object.keys(this.old).length : 0
    },
    attrLen() {
      return this.attributes ? Object.keys(this.attributes).length : 0
    },

  },
  props: {
    attributes: {
      type: Object|null,
      required: true,
    },
    old: {
      type: Object|null,
      required: false,
    },
  },
}

</script>



// WEBPACK FOOTER //
// src/components/audit/ShowMore/ModalContent.vue